







































import FeedbackComponent from '@/components/base/FeedbackComponent'
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import Component from 'vue-class-component'
import {Action} from "vuex-class";


@Component({})
export default class CRMSmsOrMailManagement extends FeedbackComponent {

  @Action('getConfigCRMDetails', StoreNamespace.CUSTOMER_SERVICE) getConfigCRMDetails: any;
  @Action('updateConfigCRM', StoreNamespace.CUSTOMER_SERVICE) updateConfigCRM: any;


  private showMailingOptions: boolean = false
  private smsValue: boolean = false
  private emailValue: boolean = false

  mounted() {
    this.getConfigCRMDetails({
      requestorCallback: this
    })
  }

  onSuccess(data?: any, requestName?: string, message?: string) {
    switch (requestName) {
      case 'crmConfigurationManagement/getConfigCRMDetails':
        this.smsValue = data.sendSmsFlag
        this.emailValue = !data.sendSmsFlag
        this.showMailingOptions = true
        break;
      case 'crmConfigurationManagement/updateConfigCRM':
        this.showMailingOptions = false
        this.getConfigCRMDetails({
          requestorCallback: this
        })
          this.showSuccessAction(this.$t('CRMConfigManagement.updateMailingTypeSuccessMessage') as string)
        break;
    }
  }


  onSmsOptionSelected(value: any) {
    this.showMailingOptions = false

    setTimeout(() => {
      this.smsValue = value
      this.emailValue = !value
      this.showMailingOptions = true
    }, 1);
  }

  onEmailOptionSelected(value: any) {
    this.showMailingOptions = false

    setTimeout(() => {
      this.smsValue = !value
      this.emailValue = value
      this.showMailingOptions = true
    }, 1);
  }

  saveChanges() {

    const body = {
      sendSmsFlag: this.smsValue
    }

    this.updateConfigCRM({
      requestorCallback: this,
      requestBody: body
    })
  }

  private showSuccessAction(message: string) {
    this.$root.$emit('showAlertNotification', {
      toShow: true,
      message: message,
      icon: 'checkCircle',
      secondsToDisappear: 3
    })
  }

};
